/**
 * BLACKFEO nas 6 pós (LPs Wix + pré-checkout embutido). Liga por data
 * (04/11 00h → 30/11 23h59 Brasília), independente da pausa do site.
 * O black-wix.js espelha estas datas e o contador (não importa módulos).
 */
import { BN26 } from "./regras";
import { urlCheckoutBlackfeo } from "./catalogo";
import { proximoResetBlackfeo } from "./blackfeo-contador";

export type PosSlugBlackfeo = "orto" | "dor" | "esporte" | "geronto" | "trauma" | "prescricao";

const INICIO = Date.parse(BN26.inicioIso);
const FIM = Date.parse(BN26.fimExclusivoIso);

export function posBlackfeoAtiva(now: number): boolean {
  return now >= INICIO && now < FIM;
}

export function descontoPosBlackfeo(slug: PosSlugBlackfeo): number {
  return slug === "trauma" || slug === "prescricao" ? 56 : 64;
}

export function checkoutPosBlackfeo(codigoEduzz: string, tipo: "unica" | "assinatura"): string {
  return urlCheckoutBlackfeo(codigoEduzz, tipo === "assinatura");
}

/** Contador das pós: zera toda segunda às 23h59, até o fim da ação (30/11 23h59 Brasília). */
export function proximoResetPosBlackfeo(now: number): number {
  if (now < INICIO) return INICIO;
  return Math.min(proximoResetBlackfeo(now), FIM - 60_000);
}
